import { makeObservable, observable, action } from 'mobx';
import { load } from 'recaptcha-v3';
import settings from '../../../global/config/settings';
import GlobalStore from '../../../global/stores/GlobalStore';

export type LoginScreen = 'login' | 'forgot';

class LoginStore {
  screen: LoginScreen = 'login';
  token: string | null = null;
  email = '';

  constructor() {
    makeObservable(this, { screen: observable, email: observable, setScreen: action, setEmail: action });
  }

  setScreen = (s: LoginScreen) => (this.screen = s);
  setEmail = (e: string) => (this.email = e);

  // Vráti recaptcha token: v2 ak je zapnutá, inak v3 podľa akcie
  getRecaptchaToken = async (action: string): Promise<string> => {
    if (GlobalStore.enabledRecaptchaV2 && GlobalStore.tokenRecaptchaV2) {
      return `v2:${GlobalStore.tokenRecaptchaV2}`;
    }
    const recaptcha = await load(settings.SITE_KEY ?? '');
    return recaptcha.execute(action);
  };
}

const singleton = new LoginStore();
export default singleton;
